import { accountTypes } from '../util/enum/api/accountTypes';

/** API AccountType on POST users/ssn (per SFH backend spec). */
export function mapSfhSsnAccountType(accountType) {
  if (accountType === accountTypes.Trust) return 'Trust';
  if (
    accountType === accountTypes.JointTenantsInCommon ||
    accountType === accountTypes.JointTenantsWithRightOfSurvivorship
  ) {
    return 'Joint';
  }
  return 'Individual';
}

export function isJointAccountType(accountType) {
  return (
    accountType === accountTypes.JointTenantsInCommon ||
    accountType === accountTypes.JointTenantsWithRightOfSurvivorship
  );
}

/**
 * Prefer account-users match when available; otherwise JWT `IsPrimaryUser`
 * (boolean or 'True'/'False' string).
 */
export function resolveIsPrimaryUser({ authUser, primaryAccountUser }) {
  if (authUser?.UserUid && primaryAccountUser?.UserUid) {
    return authUser.UserUid === primaryAccountUser.UserUid;
  }
  const claim = authUser?.IsPrimaryUser;
  return claim === true || claim === 'True';
}

/**
 * Named primary-holder IRS note for joint accounts (primary or secondary).
 * Individual / trust get the "you" copy.
 */
export function shouldShowPrimaryHolderIrsNote({
  accountType,
  primaryHolderDisplayName,
}) {
  return (
    isJointAccountType(accountType) && Boolean(primaryHolderDisplayName?.trim())
  );
}

export function buildSfhIrsDrawerCopy({
  t,
  accountType,
  primaryHolderDisplayName,
  learnMoreHref,
}) {
  const isTrust = accountType === accountTypes.Trust;
  const showPrimaryHolderNote = shouldShowPrimaryHolderIrsNote({
    accountType,
    primaryHolderDisplayName,
  });

  return {
    title: t('common.irsReportingRequired'),
    learnMoreHref,
    learnMoreText: t('irs.learnMore'),
    secureFootnote: t('irs.footNote'),
    inputLabel: isTrust ? t('common.tinFieldTitle') : t('common.ssnFieldTitle'),
    inputPlaceholder: isTrust
      ? t('sellWizard.sfhWizard.irsDrawer.placeholderTin')
      : t('sellWizard.sfhWizard.irsDrawer.placeholderSsn'),
    isTrust,
    primaryHolderDisplayName: showPrimaryHolderNote
      ? primaryHolderDisplayName.trim()
      : undefined,
    ssnAccountType: mapSfhSsnAccountType(accountType),
  };
}
